import { TnACalendarDaysDTO, TnACalendarDaysSTO } from "../../models/tna-calendar-days";
import { BaseApiService } from "../base/base-api.service";

export class TnAOverviewsCalendarsApiService extends BaseApiService<TnACalendarDaysDTO, TnACalendarDaysSTO> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnACalendarsDays",
    });
  }
}
